import React from "react";

import { ReferenciaContenido } from "../../../interfaces/ReferenciaContenido";
import ConversationsSlider from "../../molecules/conversations-slider/conversationsSlider";

import "./conversationsRotator.scss";

const ConversationsRotator = (props: ReferenciaContenido) => {
  let conversationsArr = Array();

  for (let i = 0; i < props.referenciaPlantillaContenido.length; i++) {
    let obj = {
      imagenPrincipal: props.referenciaPlantillaContenido[i].imagenPrincipal,
      title: props.referenciaPlantillaContenido[i].tituloBanner,
      info: props.referenciaPlantillaContenido[i],
    };
    conversationsArr.push(obj);
  }

  return (
    <div className="o-conversations-rotator">
      <div className="o-conversations-rotator__upper">
        <h2 className="o-conversations-rotator__upper-title">
          {props.tituloGeneral}
        </h2>
        {/*<Button
          classname='o-conversations-rotator__upper-btn'
          type='button'
          text='VER TODO'
          isDisabled={false}
        />*/}
      </div>

      <div className="o-conversations-rotator__content">
        <ConversationsSlider
          conversations={conversationsArr}
          gtmClass="conversationsRotator"
        />
      </div>
    </div>
  );
};

export default ConversationsRotator;
